// extracted by mini-css-extract-plugin
export default {"FloatingContainer":"LeftRightFloatingContainer_FloatingContainer__citIR","Left":"LeftRightFloatingContainer_Left__W6quj","Right":"LeftRightFloatingContainer_Right__oeCD-"};